import actions from './actions';

const initState = {
  loading: false,
  bikes: [],
  locations: [],
  bike: {}
};

const reducer = (state = initState, action) => {
  switch (action.type) {
    case actions.START_FETCH_BIKES:
      return { ...state, loading: true };
    case actions.END_FETCH_BIKES:
      return { ...state, loading: false };
    case actions.START_DELETING_BIKES:
      return { ...state, loading: true };
    case actions.END_DELETING_BIKES:
      return { ...state, loading: false };
    case actions.START_FETCH_LOCATIONS:
      return { ...state, loading: true };
    case actions.END_FETCH_LOCATIONS:
      return { ...state, loading: false };
    case actions.START_ADD_BIKE:
      return { ...state, loading: true };
    case actions.END_ADD_BIKE:
      return { ...state, loading: false };
    case actions.START_FETCH_BIKE:
      return { ...state, loading: true };
    case actions.END_FETCH_BIKE:
      return { ...state, loading: false };
    case actions.START_UPDATE_BIKE:
      return { ...state, loading: true };
    case actions.END_UPDATE_BIKE:
      return { ...state, loading: false };
    case actions.START_ADD_BIKE_LOCATION:
      return { ...state, loading: true };
    case actions.END_ADD_BIKE_LOCATION:
      return { ...state, loading: false };
    case actions.SET_BIKES:
      return { ...state, bikes: action.value };
    case actions.SET_LOCATIONS:
      return { ...state, locations: action.value };
    case actions.SET_BIKE:
      return { ...state, bike: action.value };
    case actions.START_BIKE_END_RENT:
      return { ...state, loading: true };
    case actions.END_BIKE_END_RENT:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default reducer;
